import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import CrmHelpButton from "../Buttons/CrmHelpButton";
import NFCTm from "assets/img/nfc-tm.svg";
import Typed from "react-typed";
import { useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import styles from 'assets/jss/Scan/scanStyle';
import { useNavigate } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import 'animate.css';
import Countdown from "react-countdown";
import { digitsEnToFa } from "persian-tools2";
import nfcGif from 'assets/gif/dash-gif.gif';
import { scanLevels } from 'helpers/scanLevels';
import { PRODUCTION_MODE } from "../../helpers/Functions";
import { detectPathUrl } from "../../helpers/detectPathUrl";

const useStyles = makeStyles(styles);
const ScanGifAndSuccessPart = (props) => {
    const { nfcError, nfcStatus, serialNumber, changeGif, isDemo, response } = props;
    const [showTransition, setShowTransition] = useState(false);
    const [resendTime, setResendTime] = useState(Date.now() + 59000);

    const classes = useStyles();
    const navigate = useNavigate();
    const goReport = () => {
        const path = detectPathUrl(`app/report?patientId=${response?.id}`);
        navigate(path);
    };
    const goHome = () => {
        const path = detectPathUrl('app/home');
        navigate(path);
    };
    useEffect(() => {
        let delayDebounceFn;
        if (nfcStatus === scanLevels.REPORT_SUCCESSED) {
            window?.ReactNativeWebView?.postMessage('scanVibration');
            delayDebounceFn = setTimeout(() => {
                setShowTransition(true);
                // Send Axios request here
            }, 100);
        }
        if (nfcError) {
            setResendTime(Date.now() + 59000);
        }
        // Cleanup fn
        return () => {
            clearTimeout(delayDebounceFn);
        };
    }, [nfcStatus, nfcError]);

    const renderer = ({ minutes, seconds, completed }) => {
        if (!completed) {
            const minutesFormat = minutes < 10 ? '0' + minutes : minutes;
            const secondsFormat = (seconds < 10 && '0' + seconds) || seconds;
            return (
                <span className={classes.countdown}>
                    {digitsEnToFa(minutesFormat)}:{digitsEnToFa(secondsFormat)}
                </span>
            );
        } else if (completed && nfcError) {
            goHome();
            return null;
        }
    };

    return (
        <>
            {nfcStatus === scanLevels.REPORT_SUCCESSED && !nfcError && (
                <Grid mt='27px'>
                    <Grid item xs={12}>
                        {isDemo ?
                            <p
                                className={classes.title}
                                style={{ color: '#753cbe', marginBottom: 0 }}
                            >دستگاه آموزشی
                            </p>
                            :
                            <p
                                className={classes.title}
                                style={{ color: '#753cbe', marginBottom: 0 }}
                            >
                                {response.firstName} {response.lastName}
                            </p>
                        }

                    </Grid>
                    <Grid item xs={12} mt='12px' mb='19px' display='flex' justifyContent='center'>
                        <span className={classes.number}>شماره دستگاه:</span>
                        <span
                            className={classes.serialNumber}>{serialNumber === true ? '...' : serialNumber}</span>
                    </Grid>
                    {/*<Share/>*/}
                    <CSSTransition timeout={10} in={showTransition} classNames={{
                        enterDone: 'animate__animated animate__zoomIn',
                        enterActive: 'animate__animated animate__zoomIn',
                    }}>
                        <Grid item xs={12} className={classes.viewReport}>
                            <Button
                                style={{ 'visibility': !showTransition ? 'hidden' : 'visible' }}
                                onClick={goReport}
                                className={classes.Button3Style}
                                type='button'
                            >
                                <span className={classes.ButtonLabel}>مشاهده داشبورد</span>
                            </Button>
                        </Grid>
                    </CSSTransition>

                </Grid>
            )}
            {nfcError &&
                <Grid container>
                    <Grid item xs={12}>
                        <p className={classes.scanAgain}>دوباره اسکن کنید</p>
                        <Countdown date={resendTime} renderer={renderer} />

                    </Grid>

                </Grid>
            }
            {nfcError &&
                <Grid className={classes.helpContainer} container>
                    <div className={classes.lineScan} />
                    <CrmHelpButton text={true} />
                </Grid>
            }
            {nfcStatus < scanLevels.NFC_READING && !nfcError && (
                <div>
                    <img
                        loop
                        src={changeGif ? nfcGif : NFCTm}
                        width={'150px'}
                        height={'150px'}
                        autoPlay
                        playsInline
                        muted
                        className={`${changeGif ? 'fade-in' : 'fade-out'}`}
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: 'auto',
                            height: '150px',
                            width: '150px',
                            marginTop: '40px',
                            marginBottom: '20px',
                        }}
                    />
                    {nfcStatus === scanLevels.INITIAL_STATES ? (
                        <Typed
                            strings={['دستگاه را به  پشت موبایل خود بچسبانید...']}
                            typeSpeed={40}
                            className={classes.helpNFCText}
                        />
                    ) : nfcStatus > scanLevels.INITIAL_STATES && nfcStatus < scanLevels.NFC_READING ? (
                        <Typed
                            strings={['در این حالت نگه دارید تا صدای دو بوق را بشنوید...']}
                            typeSpeed={60}
                            className={classes.helpNFCText}
                        />
                    ) : (
                        ''
                    )}
                </div>
            )}</>
    );
};
export default ScanGifAndSuccessPart;